import { Box } from "@material-ui/core"
import { trackFooterClicks } from "common/analytics"
import NextLink from "common/bit/NextLink"
import { LinksType } from "common/SiteLinks"
import styled from "styled-components"
import colors from "theme/colors"
import { StyledCol, TypographyRtl } from "theme/shared"

const StyledFooterCol = styled(StyledCol)`
  max-width: 169px;
  ${(p) => p.theme.breakpoints.up("md")} {
    max-width: 140px;
  }
  ${(p) => p.theme.breakpoints.up("lg")} {
    max-width: none;
  }
`
const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  &:hover {
    p {
      text-decoration: underline;
    }
  }
`

const StyledList = styled.ul`
  padding: 0px;
  margin: 0px;
`

const StyledListItem = styled.li`
  margin-bottom: 20px;
`

type FooterLinkListProps = {
  linkList: LinksType[]
  title?: string
  withIcons?: boolean
  extraButton?: JSX.Element
}

const FooterLinkList = ({
  linkList,
  title,
  withIcons,
  extraButton,
}: FooterLinkListProps) => {
  return (
    <StyledFooterCol $notCenter $gap="20px">
      <TypographyRtl variant="h4" $color={colors.white} $fontSize="20px">
        {title}
      </TypographyRtl>
      {extraButton}
      <StyledList>
        {linkList.map((item, index) => (
          <StyledListItem key={index}>
            <NextLink
              href={item.link}
              openInNewTab={item.blank}
              onClick={() => trackFooterClicks()}
            >
              <StyledBox>
                {withIcons && item?.iconComp}
                <TypographyRtl
                  variant="body1"
                  $color={withIcons ? colors.white : colors.darkGrey}
                >
                  {item.title}
                </TypographyRtl>
              </StyledBox>
            </NextLink>
          </StyledListItem>
        ))}
      </StyledList>
    </StyledFooterCol>
  )
}

export default FooterLinkList
